import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SubmitButton',
    props: {
        primary: Boolean,
        secondary: Boolean,
        disable: Boolean,
        link: Boolean,
        value: {
            type: String,
            default: "button",
        },
    },
    setup(__props) {
        const props = __props;
        // Compute the class based on the props
        const buttonClass = computed(() => ({
            primary: props.primary,
            secondary: props.secondary,
            disable: props.disable,
            link: props.link,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(buttonClass.value)
            }, _toDisplayString(__props.value), 3));
        };
    }
});
